import React from "react";
import { joinNames } from "../helpers";
import styles from "./style.module.scss";

type Step = { name: string; description?: string };
type ApplicationStepListProps = { steps: Step[]; current: number };

export default function ApplicationStepList({
    steps,
    current,
}: ApplicationStepListProps) {
    const { name: progressName } = steps[current];
    return (
        <div
            className={styles.root}
            role="progressbar"
            aria-label={progressName}
            aria-valuemax={steps.length }
            aria-valuenow={current + 1}
            aria-valuemin={1}
            aria-valuetext={`Step ${current + 1} of ${steps.length}`}
        >
            <ol className={styles.list}>
                {steps.map((a, i) => (
                    <li key={i}
                        className={joinNames(
                            styles.item,
                            i <= current ? styles.active : undefined
                        )}
                    >
                        <span className={styles.num}>{i + 1}</span>
                        <span className={styles.txt}>{a.name}</span>
                    </li>
                ))}
            </ol>
        </div>
    );
}
